import React, { useEffect, useState } from 'react';

interface ToastProps {
  message: string;
  type?: 'info' | 'success' | 'error' | 'warning';
}

const Toast: React.FC<ToastProps> = ({ message, type = 'info' }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Slide in
    setTimeout(() => setIsVisible(true), 50);

    // Auto-dismiss
    const dismissAfter = type === 'error' ? 4000 : 3000;
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, dismissAfter);

    return () => clearTimeout(timer);
  }, [type]);

  // Determine accent color based on type
  const getAccentColor = () => {
    switch (type) {
      case 'error':
        return 'border-l-red-400/60';
      case 'success':
        return 'border-l-green-400/60';
      case 'warning':
        return 'border-l-yellow-400/60';
      default:
        return 'border-l-blue-400/60';
    }
  };

  return (
    <div 
      className={`fixed bottom-6 right-6 z-[10000] px-4 py-3 rounded-xl font-medium transition-all duration-300 ease-out bg-white/[0.02] backdrop-blur-xl border border-white/[0.08] border-l-2 ${getAccentColor()} text-white/90 shadow-lg max-w-xs ${
        isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
      }`}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.02)';
      }}
    >
      <span className="text-sm">{message}</span>
    </div>
  );
};

export default Toast;
